import React, { useEffect, useState } from 'react';
import { getUserSales } from '../../services/salesServices';
import { getUserInventoriesCreator } from '../../services/inventoryServices';
import '../../styles/UserSales.css';

export default function UserSales() {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [inventariosUsuario, setInventariosUsuario] = useState([]);
  const [inventario, setInventario] = useState(1);
  const [rango, setRango] = useState('mes');
  const [fecha, setFecha] = useState('2025-05-01');

  useEffect(() => {
    const fetchVentas = async () => {
      setLoading(true);
      try {
        const data = await getUserSales(inventario, rango, fecha);
        setVentas(data);
      } catch (err) {
        setError('No se pudieron cargar las ventas');
      } finally {
        setLoading(false);
      }
    };

    fetchVentas();
  }, [inventario, rango, fecha]);

  useEffect(() => {
    const fetchInventarios = async () => {
      try {
        const data = await getUserInventoriesCreator();
        setInventariosUsuario(data);
        // Selecciona el primer inventario como predeterminado si no hay uno
        if (data.length > 0 && !inventario) {
          setInventario(data[0].FIInventario);
        }
      } catch (error) {
        console.error('Error al cargar inventarios:', error);
      }
    };
  
    fetchInventarios();
  }, []);

  return (
    <div className="info-box">
      <h2 className="card-title">🧾 Historial de Ventas</h2>

      {/* Filtros */}
      <div className="filtros-ventas">
      <select
          value={inventario}
          onChange={(e) => setInventario(e.target.value)}
          className="input-filtro"
        >
          {inventariosUsuario.map((inv) => (
            <option key={inv.FIInventario} value={inv.FIInventario}>
              {inv.FCNombreInventario}
            </option>
          ))}
        </select>
        <select
          value={rango}
          onChange={(e) => setRango(e.target.value)}
          className="input-filtro"
        >
          <option value="dia">Día</option>
          <option value="semana">Semana</option>
          <option value="mes">Mes</option>
          <option value="trimestre">Trimestre</option>
          <option value="semestre">Semestre</option>
          <option value="año">Año</option>
        </select>
        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          className="input-filtro"
        />
      </div>

      {loading ? (
        <p className="mensaje-aviso">Cargando ventas...</p>
      ) : error ? (
        <p className="mensaje-aviso">{error}</p>
      ) : ventas.length === 0 ? (
        <p className="mensaje-aviso">No hay ventas para los filtros seleccionados.</p>
      ) : (
        <table className="tabla-ventas">
          <thead>
            <tr>
              <th>📦 Producto</th>
              <th>🗓 Fecha</th>
              <th>👤 Vendedor</th>
              <th>🏷 Etiqueta</th>
            </tr>
          </thead>
          <tbody>
            {ventas.map((venta, index) => (
              <tr key={index}>
                <td>{venta.producto}</td>
                <td>{venta.fecha_venta}</td>
                <td>{venta.vendedor}</td>
                <td>{venta.etiqueta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
